//Action Types
export const FETCH_CURRENCY = 'FETCH_CURRENCY';

//Action Creator
export const fetchCurrency = (data) => ({
   type: FETCH_CURRENCY,
   data: data
});
